import classNames from "classnames";
import React from "react";

function ChartBar(props: { leftPercentage: string; widthPercentage: string }) {
  return (
    <div className="relative flex h-full w-full items-center">
      <div
        className="absolute h-2.5 w-full animate-pulse bg-gray-400"
        style={{
          left: props.leftPercentage,
          width: props.widthPercentage,
        }}
      />
    </div>
  );
}

function RowLabel(props: { child: boolean; lastRow: boolean }) {
  return (
    <>
      {props.child && <div className="w-4" />}
      <div
        className={classNames(
          "border-gray block max-w-full flex-1 truncate px-[15px] leading-normal no-underline",
          !props.lastRow && "border-b",
          props.child && "border-l bg-white",
          Features.BuildSidebar ? "h-[37.5px]" : "h-[52px]",
        )}
      >
        <div className="flex h-full w-full items-center">
          <div className="h-4 w-6 animate-pulse rounded-sm bg-gray-400" />
        </div>
      </div>
    </>
  );
}

const CHART_DATA = [
  {
    width: "100%",
    left: "0%",
    child: false,
  },
  {
    width: "50%",
    left: "50%",
    child: false,
  },
  {
    width: "22%",
    left: "50%",
    child: true,
  },
  {
    width: "22%",
    left: "50%",
    child: true,
  },
  {
    width: "26%",
    left: "50%",
    child: true,
  },
  {
    width: "50%",
    left: "50%",
    child: true,
  },
  {
    width: "50%",
    left: "50%",
    child: true,
  },
];

export default function Skeleton() {
  return (
    <div className="flex-1">
      <section
        className={classNames(
          Features.BuildSidebar ? "" : "border border-gray-400",
          "relative w-full overflow-clip rounded-lg",
        )}
      >
        {CHART_DATA.map((props, index) => {
          const lastRow = CHART_DATA.length - 1 === index;
          return (
            <div
              data-testid="waterfall-chart-row"
              className="flex items-center"
              // eslint-disable-next-line react/no-array-index-key
              key={index}
            >
              <div className="bg-silver border-gray flex w-1/4 flex-none border-r">
                <RowLabel lastRow={lastRow} child={props.child} />
              </div>
              <div
                className={classNames(
                  "border-gray relative flex w-full items-center self-stretch px-2",
                  lastRow ? "" : "border-b",
                )}
              >
                <ChartBar leftPercentage={props.left} widthPercentage={props.width} />
              </div>
            </div>
          );
        })}
      </section>
    </div>
  );
}
